import api, { apiErrorHandler } from "api";
import { TrackerConstants } from "constants/constants";
import { RootState } from "reducers/rootReducer";
import { Dispatch } from "redux";

export const getTrackerData =
  (params: { station?: string; year?: number; month?: number; week?: number }) =>
  (dispatch: Dispatch) => {
    const onError = () => dispatch({ type: TrackerConstants.TRACKER_PAGE_GET_DATA_ERROR });
    dispatch({ type: TrackerConstants.TRACKER_PAGE_GET_DATA_LOADING });
    api
      .getTrackerData(params)
      .then((res) => {
        if (res?.data) {
          dispatch({
            type: TrackerConstants.TRACKER_PAGE_GET_DATA_SUCCESS,
            payload: {
              dataList: res?.data
            },
          });
        }
      })
      .catch(apiErrorHandler(onError));
  };

export const trackerSetStation =
  (station?: string) => (dispatch: Dispatch, getStore: () => RootState) => {
    const { trackerFilters } = getStore()?.trackerTable;
    dispatch({
      type: TrackerConstants.TRACKER_PAGE_SET_FILTERS,
      payload: { ...trackerFilters, station: station },
    });
  };

export const trackerSetDate =
  (data: { week?: string; month?: string; year?: string }) =>
  (dispatch: Dispatch, getStore: () => RootState) => {
    const { trackerFilters } = getStore()?.trackerTable;
    dispatch({
      type: TrackerConstants.TRACKER_PAGE_CHANGE_DATE,
      payload: { ...trackerFilters?.date, ...data },
    });
  };

export const trackerSetType = (type: string) => (dispatch: Dispatch) => {
  dispatch({
    type: TrackerConstants.TRACKER_PAGE_CHANGE_TYPE,
    payload: type,
  });
};
